<app-upload-files [uploadFilesSettings]="uploadFilesSettings" (uploadedEvent)="newUploadedItem($event)">
</app-upload-files>

<app-loading-panel [isLoading]="isLoading"></app-loading-panel>

<div *ngIf="claimMovies" class="photos-container">

    <div fxFlex="100" fxLayoutAlign="center center">
        <h2 *ngIf="claimMovies?.length === 0">{{'mobile-center.noMovies' | translate}} </h2>
    </div>
    
    <div class="selected-file" *ngFor="let file of claimMovies">

        <div fxLayoutAlign="center center" fxLayout="column">
            <img role="none" class="img" src="./assets/img/movie.png" [alt]="file.name" (click)="showContent(file)" alt="movies"/>
           
            <div >
                <span class="small-info">
                    {{'mobile-center.storeDateShort' | translate}} : {{file.timestamp | date: 'yyyy-MM-dd HH:mm:ss'}}
                </span>
                <span class="small-info" *ngIf="file.fileSize > 0">({{file.fileSize | filesize}})</span>
            </div>
           
        </div>
    </div>
</div>

<div kendoDialogContainer #movieContent></div>